export interface VdiRequest {
  username: string;
  access_token: string;
  startDateTime: string;
  endDateTime: string;
  isRepeated: boolean;
  repeatEndDateTime?: string;
  repeatuntil?: string;
  serviceDescription: string;
  softwareSet: string;
  software: string;
  gpurequirement: boolean;
  justification: string;
  remarks?: string;
}

export interface VdiResponse {
  result: boolean;
  message?: string;
  error?: string;
  data?: {
    ticketId?: string;
    ticketNumber?: string;
    success?: boolean;
    [key: string]: any;
  };
}

export interface SoftwareOption {
  id: string;
  name: string;
  description: string;
  requiresGpu: boolean;
}

export interface SoftwareSet {
  id: string;
  name: string;
  description: string;
  software: SoftwareOption[];
}

export const SOFTWARE_SETS: SoftwareSet[] = [
  {
    id: 'python-dev',
    name: 'Python Development Environment',
    description: 'Python 3.11, VS Code, Jupyter, TensorFlow',
    software: [
      { id: 'python', name: 'Python 3.11', description: 'Latest Python runtime', requiresGpu: false },
      { id: 'vscode', name: 'VS Code', description: 'Visual Studio Code editor', requiresGpu: false },
      { id: 'jupyter', name: 'Jupyter Notebook', description: 'Interactive notebooks', requiresGpu: false },
      { id: 'tensorflow', name: 'TensorFlow', description: 'Machine learning framework', requiresGpu: true }
    ]
  },
  {
    id: 'adobe-creative',
    name: 'Adobe Creative Suite',
    description: 'Photoshop, Illustrator, InDesign',
    software: [
      { id: 'photoshop', name: 'Adobe Photoshop', description: 'Image editing software', requiresGpu: true },
      { id: 'illustrator', name: 'Adobe Illustrator', description: 'Vector graphics editor', requiresGpu: true },
      { id: 'indesign', name: 'Adobe InDesign', description: 'Desktop publishing software', requiresGpu: false }
    ]
  },
  {
    id: 'autocad-suite',
    name: 'AutoCAD Suite',
    description: 'AutoCAD, SolidWorks, MATLAB',
    software: [
      { id: 'autocad', name: 'AutoCAD', description: 'Computer-aided design software', requiresGpu: true },
      { id: 'solidworks', name: 'SolidWorks', description: '3D CAD design software', requiresGpu: true },
      { id: 'matlab', name: 'MATLAB', description: 'Mathematical computing platform', requiresGpu: false }
    ]
  },
  {
    id: 'office-365',
    name: 'Office 365',
    description: 'Microsoft Office suite',
    software: [
      { id: 'word', name: 'Microsoft Word', description: 'Word processor', requiresGpu: false },
      { id: 'excel', name: 'Microsoft Excel', description: 'Spreadsheet application', requiresGpu: false },
      { id: 'powerpoint', name: 'Microsoft PowerPoint', description: 'Presentation software', requiresGpu: false }
    ]
  },
  {
    id: 'web-dev',
    name: 'Web Development Tools',
    description: 'VS Code, Node.js, Chrome DevTools',
    software: [
      { id: 'vscode', name: 'VS Code', description: 'Code editor', requiresGpu: false },
      { id: 'nodejs', name: 'Node.js', description: 'JavaScript runtime', requiresGpu: false },
      { id: 'chrome', name: 'Chrome DevTools', description: 'Browser development tools', requiresGpu: false }
    ]
  }
]; 